import { useMemo } from 'react';
import { boldenVan, poppins } from '#/styles/fonts';
import config from '@jucy-nakuru/config/clientConfig';
import { createThemeOptionsForBrand, mapBreakPoints } from '@jucy-ui/appearance';
import { Theme } from '@mui/material';
import { createTheme as muiCreateTheme } from '@mui/material/styles';
import { Brand } from '../brand';

const testBannerHeight = 46;
const isTest = config.app.env === 'test';
export const useCreateBrandTheme = (brand?: Brand): Theme => {
    const themeOptions = useMemo(() => {
        const themeOptions = createThemeOptionsForBrand(brand);
        themeOptions.settings = {
            ...themeOptions.settings,
            footer: {
                ...themeOptions.settings?.footer,
                height: 55,
            },
        };
        themeOptions.typography = {
            ...themeOptions.typography,
            fontFamily: `${poppins.style.fontFamily}, 'Verdana', 'sans-serif'`,
            alternate: {
                fontFamily: `${boldenVan.style.fontFamily}, 'Verdana', 'sans-serif'`,
            },
        };
        const appBarSettings = themeOptions.settings?.appBar;
        if (!appBarSettings) {
            return themeOptions;
        }

        themeOptions.settings = {
            ...themeOptions.settings,
            appBar: {
                ...appBarSettings,
                testBannerHeight,
                spacer: (padding = 0) =>
                    mapBreakPoints(appBarSettings.heights, (height) => {
                        const borderTop = appBarSettings.borderTop || 0;
                        const result = height + borderTop + padding + (isTest ? testBannerHeight : 0);
                        return `${result}px`;
                    }),
            },
        };

        return themeOptions;
    }, [brand]);

    return useMemo(() => muiCreateTheme(themeOptions), [themeOptions]);
};
